// frontend/src/components/SocialLinks.jsx
import React from 'react';
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
 // FaTwitter,
 // FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

const SocialLinks = () => {
  const socials = [
    {
      icon: FaFacebook,
      url: "https://www.facebook.com/SEEngineeringTN/",
      label: "Facebook",
    },
    {
      icon: FaLinkedin,
      url: "https://www.linkedin.com/company/se-engineering-sarl/",
      label: "LinkedIn",
    },
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/seengineering.tn/",
      label: "Instagram",
    },
    { icon: FaWhatsapp, url: "https://wa.me/+21651418880", label: "WhatsApp" },
    
  ];

  return (
    <div className="flex items-center gap-4">
      {socials.map((social, index) => (
        <a
          key={index}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-300"
          aria-label={social.label}
        >
          <social.icon size={20} />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
